/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseString } from '../../models/api-response-string';
import { PagedRequestPendingMessageSearchFilter } from '../../models/paged-request-pending-message-search-filter';

export interface RequestExcelExport$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
  exportType: string;
  lang: string;
      body: PagedRequestPendingMessageSearchFilter
}

export function requestExcelExport(http: HttpClient, rootUrl: string, params: RequestExcelExport$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseString>> {
  const rb = new RequestBuilder(rootUrl, requestExcelExport.PATH, 'post');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.path('exportType', params.exportType, {});
    rb.path('lang', params.lang, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseString>;
    })
  );
}

requestExcelExport.PATH = '/v1/api/pending-messages/export-excel-background/{exportType}/{lang}';
